<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Добавить задачу в плановый сервис</h3>
        <h4>{{date}}</h4>
      </div>
      <div v-if="selectedTasks" class="modal-body pb-0">

        <div v-if="recommendation && editPermissions.date" class="alert alert-success d-flex align-items-center" role="alert">
          <div class="font-weight-bold">Рекомендуется перенести сервис на {{recommendation.recommended_date}}</div>
          <btn-action class="btn btn-sm btn-success ml-auto" @click="applyMoveRecommendation">Перенести</btn-action>
        </div>

        <div v-if="is_recommended" class="alert alert-success d-flex align-items-center" role="alert">
          <div class="font-weight-bold">Рекомендуется назначить этот сервис</div>
        </div>

        <el-date-picker
          v-model="service_date"
          type="date"
          :clearable="false"
          value-format="yyyy-MM-dd"
          align="right"
          size="small"
          class="mb-2"
          :disabled="!editPermissions.date"
        />

        <server-select
          class="mb-2"
          :disabled="!editPermissions.executor"
          v-model="selectedOperator"
          :custom-label="formatLabel"
          placeholder="Выберите исполнителя..."
          endpoint="users_by_role"
          :endpoint-params="{region_id: region_id}"
          :modifyOptions="modifyOptions"
        />
        <select v-if="tasksTypes && editPermissions.tasks" v-model="selectedTask" class="custom-select mb-2" @change="addTask">
          <option value="" disabled>Выберите задачу...</option>
          <option v-for="task in tasksTypes" :disabled="isDisabledTask(task)" :value="task">{{task.name}}</option>
        </select>
        <ul class="list-unstyled">
          <li v-for="(task, index) in selectedTasks">
            <strong>{{task.name}}</strong>
            <button v-if="editPermissions.tasks" class="btn btn-sm btn-outline-danger ml-1 py-0" @click="deleteTask(index)">&times; Удалить</button>
          </li>
        </ul>
        <div class="form-group">
           <textarea
             class="form-control"
             v-model="comment"
             placeholder="Добавить комментарий к задаче"
             :disabled="!editPermissions.save"
             rows="3"
           ></textarea>
        </div>
        <div class="alert alert-danger mt-2" v-if="error">{{ error }}</div>
      </div>
      <div class="modal-footer">
        <div>
          <btn-action
            v-if="editPermissions.save"
            class="btn btn-primary"
            :disabled="disabled"
            @click="save"
          >Назначить</btn-action>
          <btn-action
            v-if="editPermissions.remove"
            class="btn btn-outline-danger ml-2"
            :disabled="done"
            @click="remove"
          >Удалить сервис</btn-action>
          <!--<button-->
            <!--v-if="$root.canCreateService() && fromErp"-->
            <!--class="btn btn-outline-primary"-->
            <!--disabled-->
          <!--&gt;Сервис из ERP недоступен для редактирования</button>-->
        </div>
        <button type="button" class="btn btn-light" @click="$emit('hide')">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { map, find, findIndex, matches, filter } from 'lodash'

  export default {
    props: [
      'machine_id',
      'date',
      'service',
      'default_tech',
      'default_operator',
      'region_id',
      'date_range',
    ],
    data () {
      return {
        selectedOperator: null,
        selectedTask: '',
        term: null,
        service_id: this.service.id,
        is_recommended: this.service.is_recommended,
        executor: this.service.executor,
        done: this.service.done,
        recommendation: this.service.recommendation,
        service_date: this.date,
        error: null,
        comment: null,
        editPermissions: {
          date: true,
          executor: true,
          tasks: true,
          remove: false,
          save: true,
        }
      }
    },
    methods: {
      save () {
        if (this.selectedTasks.length === 0) {
          return this.remove()
        } else {
          let data = {
            task_types: map(this.selectedTasks, (current) => current.id),
            date: this.service_date,
            machine_id: this.machine_id,
            executor_id: this.selectedOperator.id,
            date_range: this.date_range,
            comment: this.comment,
          }
          let query
          if (this.service_id) {
            query = api.put(`services/planned/${this.service_id}`, data)
          } else {
            query = api.post('services/planned', data)
          }
          return query.then((data) => {
            this.$emit('hide', Object.assign(data.data, {deleted: false}))
          }).catch((error) => {
            if (error.response) {
              this.error = 'Неподходящая дата'
            }
          })
        }
      },
      applyMoveRecommendation () {
        // @todo: fix that blinking stays after service was moved
        return api.put(`services/planned/${this.service_id}`, {date: this.recommendation.recommended_date, date_range: this.date_range}).then((data) => {
          this.$emit('hide', Object.assign(data.data, {deleted: false}))
        })
      },
      remove () {
        if (window.confirm('Удалить сервис?')) {
          return api.delete(`services/planned/${this.service_id}`).then(() => {
            this.$emit('hide', {deleted: true})
          })
        }
      },
      addTask () {
        if (this.selectedTask !== '' && !find(this.selectedTasks, current => this.selectedTask.id === current.id)) {
          this.selectedTasks.push(this.selectedTask)
        }
        this.selectedTask = ''
      },
      deleteTask (index) {
        this.selectedTasks.splice(index, 1)
      },
      isDisabledTask (task) {
        let tasksTypes = [
          'Плановое обслуживание',
          'Смена матрицы',
          'Профилактическое обслуживание на складе (ППРс)',
        ]
        let checkTask = 'Проверка качества обслуживание и ремонта'
        return (this.disableSomeTasks && tasksTypes.includes(task.name)) ||
          (this.selectedTasks.length > 0 && ((this.selectedTasks[0].name !== checkTask && task.name === checkTask) || (this.selectedTasks[0].name === checkTask && task.name !== checkTask)))
      },
      formatLabel (option) {
        if (option) {
          return ((this.default_operator && option.id === this.default_operator.id)
            ? 'Назначенный оператор: '
            : (this.default_tech && option.id === this.default_tech.id)
              ? 'Назначенный техник: '
              : '') +
            Vue.options.filters.fullName(option)
        }
      },
      modifyOptions (options) {
        if (!this.selectedOperator && this.executor) {
          this.selectedOperator = this.executor
        }
        if (this.default_tech) {
          let index = findIndex(options, matches({id: this.default_tech.id}))
          if (index !== -1) {
            options.splice(index, 1)
            options.unshift(this.default_tech)
          }
        }
        if (this.default_operator) {
          let index = findIndex(options, matches({id: this.default_operator.id}))
          if (index !== -1) {
            options.splice(index, 1)
            options.unshift(this.default_operator)
          }
        }
        return options
      },
    },
    watch: {
      selectedOperator (newOperator, oldOperator) {
        if (oldOperator !== null) {
          this.selectedTasks = []
        }
      },
    },
    asyncComputed: {
      allTasksTypes () {
        return api
          .get('tasks')
          .then(({data}) => data.data)
      },
      selectedTasks: {
        get () {
          if (this.service_id) {
            return api
              .get('services/planned/' + this.service_id)
              .then(({data}) => {
                this.editPermissions = data.data.editPermissions
                this.comment = data.data.comment
                return data.data.tasks.map((current) => {
                  return {
                    id: current.type.id,
                    name: current.type.name,
                  }
                })
              })
          } else {
            return []
          }
        },
        default: [],
      },
    },
    computed: {
      tasksTypes () {
        if (!this.selectedOperator) return
        // Filter tasks by role
        if (this.selectedOperator.role) {
          const serviceTasks = [
            'Инкассация',
            'Загрузка ингредиентов',
            'Выгрузка-загрузка монет',
            'Санитарная обработка',
            'Смена матрицы',
          ]
          const techTasks = [
            'Инкассация',
            'Оперативный ремонт',
            'Плановое обслуживание',
            'Смена матрицы',
            'Профилактическое обслуживание на складе (ППРс)',
            'Выгрузка-загрузка монет',
          ]

          let availableTasks = [
            'Проверка качества обслуживание и ремонта',
          ]
          switch (this.selectedOperator.role.name) {
            case 'service': availableTasks = serviceTasks
              break
            case 'tech': availableTasks = techTasks
              break
            case 'service_superior': availableTasks = availableTasks.concat(serviceTasks)
              break
            case 'tech_superior': availableTasks = availableTasks.concat(techTasks)
          }

          return filter(this.allTasksTypes, (task) => availableTasks.includes(task.name))
        }

        return this.allTasksTypes
      },
      disabled () {
        return this.done || this.selectedOperator === null || (this.service_id === null && this.selectedTasks.length === 0)
      },
      disableSomeTasks () {
        let tasksTypes = [
          'Плановое обслуживание',
          'Смена матрицы',
          'Профилактическое обслуживание на складе (ППРс)',
        ]
        return this.selectedTasks.some((task) => tasksTypes.includes(task.name))
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/service-modal-planned.vue